module.exports = __webpack_public_path__ + "static/media/react.556fffc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/react.png
// module id = 158
// module chunks = 0